import { FishingTrip } from '../../types';
import { TripSchema } from '@/schemas/tripSchema';
import { doc, deleteDoc, getDocs, collection } from 'firebase/firestore';
import { safeWrite } from './coreService';

import { query, where } from 'firebase/firestore';

export const fetchTrips = async (firestore: any): Promise<FishingTrip[]> => {
  const snap = await getDocs(collection(firestore, 'trips'));
  return snap.docs.map(d => TripSchema.parse(d.data()));
};

export const fetchTripByCode = async (firestore: any, code: string): Promise<FishingTrip | null> => {
  const q = query(collection(firestore, 'trips'), where('fishingCode', '==', code));
  const snap = await getDocs(q);
  if (snap.empty) return null;
  return TripSchema.parse(snap.docs[0].data());
};

export const addTrip = async (firestore: any, trip: FishingTrip) => {
  await safeWrite(doc(firestore, 'trips', trip.id), trip);
};

export const updateTrip = async (firestore: any, trip: FishingTrip) => {
  await safeWrite(doc(firestore, 'trips', trip.id), trip);
};

export const removeTrip = async (firestore: any, id: string) => {
  await deleteDoc(doc(firestore, 'trips', id));
};
